import { StreamingPlayerTypography } from '@heardis/stream-contracts';
import CloseIcon from '../../elements/icons/CloseIcon';
import classes from './InfoContainer.module.css';

interface InfoContainerProps {
  backgroundColor: string;
  typography: StreamingPlayerTypography;
  hideInfoContainer?: () => void;
  children: React.ReactNode;
}

export default function InfoContainer({ backgroundColor, typography, hideInfoContainer, children }: InfoContainerProps) {
  const { fontFamily, fontSize, fontWeight, color } = typography;

  return (
    <div className={classes.infoContainerWrapper}>
      <section className={classes.infoContainer} style={{ backgroundColor, fontFamily, fontSize, fontWeight, color }}>
        {hideInfoContainer && (
        <button type="button" className={classes.closeIcon} onClick={hideInfoContainer}>
          <CloseIcon />
        </button>
        )}
        <div className={classes.infoContainerContent}>
          {children}
        </div>
      </section>
    </div>
  );
}
